<template>
  <v-navigation-drawer
    v-if="$vuetify.breakpoint.mdAndDown"
    id="core-navigation-drawer"
    v-model="drawer"
    class="pa-6"
    :dark="false"
    :right="$vuetify.rtl"
    app
    clipped
    width="100vw"
    v-bind="$attrs"
    style="background: #000"
  >
    <v-card-actions>
      <v-btn class="ma-0" text @click="$router.push('/')">
        <v-img :aspectRatio="85 / 24" width="85" contain :src="Logo" />
      </v-btn>
      <v-spacer />
      <v-btn icon color="white" @click="drawer = false">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </v-card-actions>

    <v-list class="mt-8 ml-4" dark nav>
      <v-list-item @click="$router.push('/drops')">
        <v-list-item-title class="nav-item">Drops</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$router.push('/marketplace')">
        <v-list-item-title class="nav-item">Marketplace</v-list-item-title>
      </v-list-item>
      <v-list-item @click="$router.push('/challenges')">
        <v-list-item-title class="nav-item">Challenges</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="user && user.user"
        @click="$router.push('/collection')"
      >
        <v-list-item-title class="nav-item">My Collection</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-row class="mx-8" style="margin-top: 160px;">
      <v-col cols="12">
        <div class="socialMediaTitle">
          Social Media
        </div>
      </v-col>
      <v-col cols="12">
        <v-card-actions class="ma-0 pa-0">
          <v-btn
            class="socialMediaIcon"
            icon
            @click="openLink(socialMedia.discord.link)"
          >
            <v-img :src="socialMedia.discord.image" width="24" />
          </v-btn>
          <v-btn
            class="socialMediaIcon"
            icon
            @click="openLink(socialMedia.twitter.link)"
          >
            <v-img :src="socialMedia.twitter.image" width="24" />
          </v-btn>
          <v-btn
            class="socialMediaIcon"
            icon
            @click="openLink(socialMedia.medium.link)"
          >
            <v-img :src="socialMedia.medium.image" width="24" />
          </v-btn>
          <v-btn
            class="socialMediaIcon"
            icon
            @click="openLink(socialMedia.linktree.link)"
          >
            <v-img :src="socialMedia.linktree.image" width="24" />
          </v-btn>
        </v-card-actions>
      </v-col>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
  import Logo from '@/assets/appbar/Logo-mobile-inverse.png';
  import DiscordIcon from '@/assets/appbar/discord.png';
  import LinktreeIcon from '@/assets/appbar/linktree.png';
  import TwitterIcon from '@/assets/appbar/twitter.png';
  import MediumIcon from '@/assets/appbar/medium.png';
  import { mapState } from 'vuex';

  export default {
    name: 'DashboardCoreDrawer',

    props: ['address', 'provider', 'chainId', 'isOnCorrectNetwork'],

    data() {
      return {
        Logo: Logo,
        socialMedia: {
          discord: {
            image: DiscordIcon,
            link: 'https://discord.com/invite/5U6B22yxmE',
          },
          twitter: {
            image: TwitterIcon,
            link: 'https://twitter.com/Momentibles',
          },
          linktree: {
            image: LinktreeIcon,
            link: 'https://linktr.ee/momentibles',
          },
          medium: {
            image: MediumIcon,
            link: 'https://momentibles.medium.com/',
          },
        },
      };
    },

    computed: {
      ...mapState({
        user: (state) => state.user,
      }),
      drawer: {
        get() {
          return this.$store.state.drawer;
        },
        set(val) {
          this.$store.commit('SET_DRAWER', val);
        },
      },
    },

    methods: {
      scrollTo(id) {
        document.getElementById(id).scrollIntoView(true);
        this.drawer = false;
      },
      openLink(link) {
        window.open(link, '_blank');
      },
    },
  };
</script>

<style scoped>
  .nav-item {
    font-size: 32px !important;
    font-family: Work Sans !important;
    font-style: normal !important;
    font-weight: 700 !important;
    line-height: 32px !important;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .connectButton {
    font-family: Assistant;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    border-radius: 24px;
    border: 1.5px solid #ffffff;
    box-sizing: border-box;
    height: 48px;
  }

  .socialMediaTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    letter-spacing: 0.003em !important;
    text-transform: uppercase !important;
    color: #fff !important;
  }

  .socialMediaIcon {
    width: 40px !important;
    height: 40px !important;
    margin-right: 16px !important;
  }
</style>
